export const formatExtraDefaultValues = () => (props) => {
  return props;
};

export const formatExtraDataBeforeSubmit = (props) => {
  return props;
};
